/* global searchFormConfig */
/* global priceHistoryConfig */
import React from "react"
import ReactDOM from "react-dom"
import FeaturedCarsSlider from "../FeaturedCarsSlider/"
import PriceHistoryGraph from "../PriceHistoryGraph"
import { renderFeaturedCarsSlider as renderTopFeaturedCarsSlider } from "../load_featured_cars_sliders"
import SearchFormContainer from "../SearchFormContainer"

let carousels = {}

window.listingCarouselViewed = (carouselNode) => {
  const carouselNr = carouselNode.getAttribute("data-carousel-nr")
  const newProps = { ...carousels[carouselNr].props, willBeInView: true }
  ReactDOM.render(<FeaturedCarsSlider {...newProps} />, carouselNode)
}

const renderSearchForm = () => {
  const searchForm = document.getElementById("search-filters")
  const searchFormPropsUrl = searchForm.getAttribute(
    "data-search-form-props-url"
  )
  const miniForm = searchForm.hasAttribute("data-mini")
  if (searchForm) {
    return ReactDOM.render(
      <SearchFormContainer
        searchFormPropsUrl={searchFormPropsUrl}
        miniForm={miniForm}
      />,
      searchForm
    )
  }
}

const renderListingFeaturedCarsSliders = () => {
  const listingsNode = document.getElementById("results")
  if (!listingsNode) return
  const dataString = listingsNode.getAttribute("data-featured-carousels")
  if (!dataString) return
  const data = JSON.parse(dataString)
  if (!data) return

  data.forEach((item, i) => {
    // the carousel is inserted to be the position-th element in the listing
    const listingItemNode =
      listingsNode.querySelectorAll(".listing-item")[item.position - 1]

    // There are not enough listing items
    if (!listingItemNode) return

    const nodeToInsert = document.createElement("div")
    nodeToInsert.setAttribute("data-lazyload-trigger", "listingCarouselViewed")
    nodeToInsert.setAttribute("data-carousel-nr", i)

    listingItemNode.insertAdjacentElement("beforebegin", nodeToInsert)
    carousels[i] = renderFeaturedCarsSlider(nodeToInsert, item.data)
  })
}

const renderPriceHistoryGraph = () => {
  const priceHistoryGraphNode = document.getElementById("price-history-graph")

  if (priceHistoryGraphNode) {
    return ReactDOM.render(
      <PriceHistoryGraph {...priceHistoryConfig} />,
      priceHistoryGraphNode
    )
  }
}

const renderFeaturedCarsSlider = (node, data) => {
  return ReactDOM.render(<FeaturedCarsSlider {...data} />, node)
}

document.addEventListener("DOMContentLoaded", () => {
  renderListingFeaturedCarsSliders()
  renderPriceHistoryGraph()
  renderTopFeaturedCarsSlider()
  if (window.location.href.indexOf("search_form_ssr") === -1) {
    renderSearchForm()
  }
})
